import React, { useEffect, useState } from "react";
import './AppointmentPage.css'
import { ChevronRight, ChevronDown, Phone } from "lucide-react";
import logo from "../../Assets/images/ldc_logo_new.png";
import Appointmenttype from "../Dashboard/Appointmenttype";
import BookingForm from "../Dashboard/BookingForm";
import ClinicBooking from "../Dashboard/ClinicBooking";
import PreferredTime from "../Dashboard/PreferredTime";
import { useNavigate, useParams } from "react-router-dom";
import { universalDummyData, mockAppointmentData, mockHealthScreenData, mockData,getAllHealthScreenData, location } from "./data";
// src\Component\BookingJourney\deleteThisLater.js
import {appointmentDummy} from './deleteThisLater.js'

// src\Component\Dashboard\AppointmentSelection.js
import AppointmentSelection from '../Dashboard/AppointmentSelection'
import AppointmentSelectionHardcoded from "./StepComponents/AppointmentSelectionHardcoded";
import Step4 from "./StepComponents/Step4";
import axios from "axios";
import BookingJourney from "./index.js";
import BookingDetailsNext from "./BookingDetailsForCancel.js";
import NoPageFound from "../NoPageFound.js";
import DateValidation from "./DateValidation.jsx";

const ReschedulePage = () => {
  const navigate = useNavigate();
  const { encryptedId } = useParams();
  const [currentStep, setCurrentStep] = useState(0);// we commeted 1step so it will start from two
  //3rd step type specification
  const [clinicBookingType, setClinicBookingType] = useState("");
  const [showAppointmentSelection, setShowAppointmentSelection] = useState(false);
  const [gpDuration, setGpDuration] = useState(false)
  const [gpLang, setGpLang] = useState()
  const [allClinics, setAllClinics] = useState({})

  const [combineAllClinicAndClinicById , setCombineAllClinicAndClinicById] = useState([])

  const [showAppoinmentData, setShowAppoinmentData] = useState({})
  const [getAppointmentDownPart, setGetAppointmentData] = useState({})
  const [bookingDetails,setBookingDetails]=useState({})
  const [step4next,setStep4next]=useState(false)
  const [ encryptBookingDetails , setEncryptedBookingDetails] = useState({})
  const [pageNotFound, setPageNotFound] = useState(false);
  const [loading,setLoading]=useState(true)
  const [dataExists, setDataExists] = useState(false);


  const [hideDetails, setHideDetails] = useState(false);// hide booking details render section 

  // appointmentSelection page 
  const [showAppoinmentDataDisplay, setshowAppoinmentDataDisplay] = useState(undefined)

  const productCategoryId = encryptBookingDetails?.product_category_name == "Health screens" ? 2 : 1; 
  const productCategoryName =  encryptBookingDetails?.product_category_name; 
  const ProductName = encryptBookingDetails?.product_name || ""; 


  // let bookingDetails = {
  //   date: "20 June, 2025",
  //   time: "11:45",
  // };

  // for Booking form we need the duration api and language api call 



  useEffect(() => {
    if (encryptedId) {
      fetchAppointmentDetails(encryptedId);
    }
  }, [encryptedId]);

  const fetchAppointmentDetails = async (id) => {
    // console.log("fetching details for encrypted id " , id )
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URLOPEN}get-appointment/${id}`);
      setLoading(false)
      // console.log("encryptedId_details", res.data)
      // setShowAppoinmentData(res.data?.data);
      setEncryptedBookingDetails(res.data?.data); // API RESPONSE
      // setEncryptedBookingDetails(ressss?.data); // HARDCODED
    } catch (err) {
      console.error("Failed to fetch appointment", err);
      setPageNotFound(true);
    }
  };

    // Fetch and transform the API response
    const fetchGpDuration = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URLOPEN}appointment-duration`,
          {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              category: "clinician_type"
            }
          }
        );

        // need format like this 
            // Transform the array to an object with duration_id as key
            
        const formattedData = response.data.data.reduce((acc, item) => {
          acc[item.duration_id] = item;
          return acc;
        }, {});

        // const formattedData = response.data.data.reduce((acc, item) => {
        //   acc[item.duration_id] = {
        //     duration: item.duration,
        //     content: item.content
        //   };
        //   return acc;
        // }, {});

        // setGpDuration(response.data);
        setGpDuration(formattedData);
      } catch (error) {
        console.error("Error fetching health screen data:", error);
      }
    };
    const fetchGpLanguage = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URLOPEN}languages`,
          {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              category: "clinician_type"
            }
          }
        );

        // need format like this 
            // Transform the array to desired format
        const formattedData = response.data.data.map(lang => ({
          label: lang.language_name,
          value: lang.language_id
        }));

        // setGpLang(response.data);
        setGpLang(formattedData);
        // console.log("Formatted health screen data:", formattedData);
      } catch (error) {
        console.error("Error fetching health screen data:", error);
      }
    };
    const fetchAllClinic = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URLOPEN}clinics`,
          {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              category: "clinician_type"
            }
          }
        );

        // need format like this 
            // Transform the array to desired format
        // const formattedData = response.data.data.map(lang => ({
        //   label: lang.language_name,
        //   value: lang.language_id
        // }));

        const formattedData = response.data.data.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});

        setAllClinics(response.data);
        setCombineAllClinicAndClinicById(formattedData)
        // setGpLang(formattedData);
        // console.log("Formatted health screen data:", formattedData);
      } catch (error) {
        console.error("Error fetching all clinic data:", error);
      }
    };




    useEffect(() => {

  
      fetchGpDuration();
      fetchGpLanguage()
      fetchAllClinic()
    }, []);






    function getProductNameOrIdByKeyword(planString) {
      // Load the stored product map or fallback to defaults
      let products = {};
      const stored = localStorage.getItem('nongroupproductid');
      if (stored) {
        try {
          products = JSON.parse(stored);
        } catch {
          console.error("Invalid JSON in localStorage");
          products = {};
        }
      }
      if (Object.keys(products).length === 0) {
        products = {
          201: "Vital",
          202: "Bronze",
          203: "Silver",
          204: "Gold",
          205: "Platinum",
          4: "Vital (15 minutes)",
          5: "Bronze (60 minutes)",
          6: "Gold (90 minutes)",
          7: "Silver (75min)",
          10: "Platinum",
          18: "r888",
          20: "r888178",
          22: "Diamond"
        };
      }
    
      // Build reverse lookup: keyword → id
      const map = {};
      Object.entries(products).forEach(([id, name]) => {
        const keyword = name.split(/\s|\(/)[0].toLowerCase(); 
        // use first word or up to first "("
        map[keyword] = Number(id);
      });
    
      // Normalize input, extract first word-like token
      const firstToken = planString.trim().split(/\s|\(/)[0].toLowerCase();
    
      return map[firstToken] ?? null;
    }
    
    // Examples:
    // console.log( "kkkkkkkkkk",getProductNameOrIdByKeyword(ProductName));     // 204 or 6 depending on stored map
    // console.log( "kkkkkkkkkk",getProductNameOrIdByKeyword("Silver package deluxe"));        // 203 or 7
    // console.log( "kkkkkkkkkk",getProductNameOrIdByKeyword("Unknown plan"));                 // null
    


    // frop product name get plan for hs 

    const originalBookingDetails = {
      "step":currentStep,
      encryptBookingDetails, 
      "showAppoinmentData": {
        "Loading":loading,
        "cancellation_charge": encryptBookingDetails?.cancellation_charge_details?.amount || encryptBookingDetails?.cancellation_charge  || 0,
        "rescheduling_charge": encryptBookingDetails?.rescheduling_charge_details?.amount || encryptBookingDetails?.rescheduling_charge || 0,
        "duration": getDurationIdFromText(encryptBookingDetails?.duration_text),
        // "language": {
        //   "value": getLanguageValue(encryptBookingDetails?.language_name, gpLang),
        //   "label": encryptBookingDetails?.language_name
        // },
        "language": getLanguageValue(encryptBookingDetails?.language_name, gpLang) || 1,
        "gender": encryptBookingDetails?.preferred_gender ,
        // "price": encryptBookingDetails?.charges?.replace(/[^\d.]/g, '') || "40.00",
        "price": encryptBookingDetails?.charges,
        "type": "BookingForm",
        "slot": {
          "date": encryptBookingDetails?.start_time?.split(",")[0]?.trim() || "02 Jul 2025",
          "info": {
            "start_time": encryptBookingDetails?.start_time?.split(",")[1]?.trim() || "10:30 AM",
            "end_time": encryptBookingDetails?.end_time?.split(",")[1]?.trim() || "10:30 AM"
          },
          "clinicData": {
            "id": null, // Will be set when selecting a clinic
            "name": encryptBookingDetails?.clinic_name || "Admin Dorset Rise",
            "address": encryptBookingDetails?.clinic_address || "123 Main Street",
            "latitude": parseFloat(encryptBookingDetails?.clinic_latitude) || 51.5074,
            "longitude": parseFloat(encryptBookingDetails?.clinic_longitude) || -0.1278,
            "description": encryptBookingDetails?.clinic_description || "<p>Modern medical facility</p>",
            "contact_number": encryptBookingDetails?.clinic_contact_number || "020 3993 0813",
            "website": encryptBookingDetails?.clinic_website || "https://clinic1.com"
          }
        },
        "clinic": {
          "productCategory": {
            "non_gp_product_id" : getProductNameOrIdByKeyword(ProductName)  , 
            "title": encryptBookingDetails?.product_category_name,
            "product_category_id": productCategoryId, // Assuming GP appointment
            "product_id" : getProductNameOrIdByKeyword(ProductName), 
            "prodcut_name" : ProductName  || null
          },
          "non_gp_product_id": getProductNameOrIdByKeyword(ProductName)
        }
      },
      "data": {
        "durationObjectById": gpDuration || {
          "1": { "duration": "15" },
          "2": { "duration": "30" }
        },
        "isProtected": false,
        "languageData": gpLang 
        // || [
        //   {
        //     "value": "en",
        //     "label": "English"
        //   },
        //   {
        //     "value": "ar",
        //     "label": "Arabic"
        //   },
        //   {
        //     "value": "es",
        //     "label": "Spanish"
        //   }
        // ]
        ,
        "allClinicData": allClinics?.data || [],
        "allClinicDataByID": combineAllClinicAndClinicById
      },
      "hide": false, 
      appointMentId  : encryptedId || encryptBookingDetails?.appointment_id || null
    };
 

    useEffect(() => {
      //ready data for clinicBooking
      const formatDataForAppointment = {
        showAppoinmentData : {
          clinic: {
            productCategory: {
              title: "Gp appointmnet",
              product_category_id: 1,
            },
          },
        //   gender: "male",
        //   language: {
        //     label: "English",
        //     value: 1,
        //   },
        //   duration: 1,
        },
        data : {
          clinic : {
            "id": 40,
            "name": "City Medical Center",
            "latitude": "51.5074",
            "longitude": "0.1278",
            "address": "123 Medical St, London",
            "clinic_website_description": "<p>Modern medical facility</p>",
            "position": "Main Building"
        },
        // clinic : allClinics[0], // add first clinic 
        // durationObjectById : {
        //   1: {duration: '15'},
        //   2: {duration: '30'}
        // },
          allClinicData : allClinics, 
          allClinicDataByID : combineAllClinicAndClinicById,
          isProtected : false
        },
      }
      setShowAppoinmentData(formatDataForAppointment)
    }, [allClinics,combineAllClinicAndClinicById ])
    

  const handleContinue = () => {
    setCurrentStep((prev) => prev + 1);
  };

  //! step 1 dummy data start [getAllHealthScreenData]
  
  const callbackAppointment = (data, formType) => {
    

  //    let today = new Date();
  // let year = today.getFullYear();

   let today = new Date();
  let year = today.getFullYear();
  const beforeMinutes = encryptBookingDetails?.product_name?.match(/(\d+)\s*minutes/);
  const durationCalulatedByProductPlanForHealth = beforeMinutes?.[1]

    setBookingDetails({
      appointMentId  : encryptedId || encryptBookingDetails?.appointment_id || null,
      callbackData:{clinicData:data.clinicData},
    oldDataExist:true,
  //   oldData:{

  //     duration: 45,
  // price: 120,
  // date: "Thu, 20 Jun2025",
  // time: "11:45",
  // clinic: {
  //   lat: 51.5308,
  //   lng: -0.1238,
  //   name: "Kings Crosshhhhhhhhhhhhhh",
  //   id: "32",
  //   address:"Suite 3-7, 344-354 Gray's Inn Road, London, WC1X 8BP"
  // }
  //   },

  oldData:{
    encryptBookingDetails, 
    duration: encryptBookingDetails?.duration_text ||  durationCalulatedByProductPlanForHealth,
    price: encryptBookingDetails.charges,
    date: encryptBookingDetails?.start_time?.split(",")[0]?.trim() || "02 Jul 2025",
    time:encryptBookingDetails?.start_time?.split(",")[1]?.trim(),
    // clinic: {
    //   "id": null, // Will be set when selecting a clinic
    //   "name": encryptBookingDetails?.clinic_name || "Admin Dorset Rise",
    //   "address": encryptBookingDetails?.clinic_address || "123 Main Street",
    //   "latitude": parseFloat(encryptBookingDetails?.clinic_latitude) || 51.5074,
    //   "longitude": parseFloat(encryptBookingDetails?.clinic_longitude) || -0.1278,
    //   "description": encryptBookingDetails?.clinic_description || "<p>Modern medical facility</p>",
    //   "contact_number": encryptBookingDetails?.clinic_contact_number || "020 3993 0813",
    //   "website": encryptBookingDetails?.clinic_website || "https://clinic1.com"
    // },
    "clinic": {
            "id": null, // Will be set when selecting a clinic
      "name": encryptBookingDetails?.clinic_name || "Admin Dorset Rise",
      "address": encryptBookingDetails?.clinic_address || "123 Main Street",
      "latitude": parseFloat(encryptBookingDetails?.clinic_latitude) || 51.5074,
      "longitude": parseFloat(encryptBookingDetails?.clinic_longitude) || -0.1278,
      "description": encryptBookingDetails?.clinic_description || "<p>Modern medical facility</p>",
      "contact_number": encryptBookingDetails?.clinic_contact_number || "020 3993 0813",
      "website": encryptBookingDetails?.clinic_website || "https://clinic1.com",
      "productCategory": {
        "non_gp_product_id" : getProductNameOrIdByKeyword(ProductName)  , 
        "title": encryptBookingDetails?.product_category_name,
        "product_category_id": productCategoryId, // Assuming GP appointment
        "product_id" : getProductNameOrIdByKeyword(ProductName), 
        "prodcut_name" :  ProductName  || null
      },
      "non_gp_product_id": getProductNameOrIdByKeyword(ProductName)
    },
    
    // language_name: encryptBookingDetails?.language_name,
    // gender :  encryptBookingDetails?.preferred_gender?.charAt(0).toUpperCase() + encryptBookingDetails?.preferred_gender?.slice(1),

    "language": getLanguageValue(encryptBookingDetails?.language_name, gpLang) || 1,
    "selectedLanguage" : { label : encryptBookingDetails?.language_name},
    "gender": encryptBookingDetails?.preferred_gender || encryptBookingDetails?.patient_gender || "no_preferance",


  },
    date:data.date + year||  "20 June, 2025",
    time:data.info.start_time|| "11:45",
    isProtected : false,
    newData : {
        price :`  ${data?.info?.price}`,
    },
    // callbackData:{"date":data.date,"info":data.info,"slot":data.slot},
    showAppoinmentData : {
            price: data.info.price,
            non_gp_product_id:getProductNameOrIdByKeyword(ProductName),
            clinic: {
              productCategory: {
                non_gp_product_id:getProductNameOrIdByKeyword(ProductName),
                "title": encryptBookingDetails?.product_category_name,
                product_category_id: productCategoryId,
                "product_id" : getProductNameOrIdByKeyword(ProductName), 
              },
            },
            // gender: "male",
            // language: {
            //   label: "English",
            //   value: 1,
            // },
            // duration: 1,
            // gender :  encryptBookingDetails?.preferred_gender?.charAt(0).toUpperCase() + encryptBookingDetails?.preferred_gender?.slice(1),


            "language": getLanguageValue(encryptBookingDetails?.language_name, gpLang) || 1,
            "selectedLanguage" : { label : encryptBookingDetails?.language_name},
            "gender": encryptBookingDetails?.preferred_gender || encryptBookingDetails?.patient_gender || "no_preferance",
      
          },
          data : {
            clinic : {
              "id": 40,
              "name": "City Medical Center",
              "latitude": "51.5074",
              "longitude": "0.1278",
              "address": "123 Medical St, London",
              "clinic_website_description": "<p>Modern medical facility</p>",
              "position": "Main Building"
          },
          // durationObjectById : {
          //   1: {duration: '15'},
          //   2: {duration: '30'}
          // },
          // isProtected=false,
            allClinicData : data.clinicData || "", 
            allClinicDataByID : combineAllClinicAndClinicById,
            isProtected : false
          }
        })
        // setStep4next(true)

  //   bookingDetails = {
  //   date:data.date + year||  "20 June, 2025",
  //   time:data.info.start_time|| "11:45",
  //   isProtected : false,
  // };
    // handleContinue();

    setCurrentStep(4)
  };



  //! step 1 dummy data end

  //! step 2 dummy data start [mockAppointmentData, mockHealthScreenData, mockData ]






  //! step 2 dummy data end

  //! step 3 dummy data start [universalDummyData]

  // Modified callback for ClinicBooking
  const callbackClinicBooking = (data, type) => {
    setDataExists(false)

    if (!data) return;

    let selectedLanguage;
    if (typeof showAppoinmentData.showAppoinmentData.language) {
      const langId = showAppoinmentData.showAppoinmentData.language
      // If language comes as just the value (number)
      const langObj = gpLang.find(lang => lang.value === langId);
      selectedLanguage = {
        label: langObj?.label || 'English', // fallback to English
        value: langObj?.value || showAppoinmentData.showAppoinmentData.language
      };
    }

    const appointmentPayload = {
      showAppoinmentData: {

        // clinic : showAppoinmentData.showAppoinmentData.clinic || "Annul",
        "clinic": {
          "productCategory": {
            "non_gp_product_id" : getProductNameOrIdByKeyword(ProductName)  , 
            "title": encryptBookingDetails?.product_category_name,
            "product_category_id": productCategoryId, // Assuming GP appointment
            "product_id" : getProductNameOrIdByKeyword(ProductName), 
            "prodcut_name" :  ProductName  || null
          },
          "non_gp_product_id": getProductNameOrIdByKeyword(ProductName)
        },
        "gender": encryptBookingDetails?.preferred_gender || encryptBookingDetails?.patient_gender || "male",
        duration : productCategoryId === 1 ? getDurationIdFromText(encryptBookingDetails?.duration_text) : null ,
        // duration : 1,
        type: "PreferredTime",
        // language :{
        //   "value": getLanguageValue(encryptBookingDetails?.language_name, gpLang),
        //   "label": encryptBookingDetails?.language_name || "English"
        // },
        "language": getLanguageValue(encryptBookingDetails?.language_name, gpLang) || 1,
        selectedClinics: data.selectedClinics,
        selectedSlots: data.selectedSlots
      },
      data: {
        "durationObjectById": gpDuration || {
          "1": { "duration": "15" },
          "2": { "duration": "30" }
        },
        isProtected:false,
        "allClinicData": allClinics , 
        allClinicDataByID: combineAllClinicAndClinicById,
        "languageData": gpLang ,
        date: new Date().toISOString().split('T')[0] // Current date
      }


    };
    if(data.selectedSlots.length > 0 ){
      setGetAppointmentData(appointmentPayload)

      setShowAppointmentSelection(true);      
    }

  };
  

  const callBackForbackpageClinicBooking = (page) => {
    setCurrentStep(currentStep - 1 )
  };



  const callBackForbackpagePreferredTime = (page) => {
  };

    //! New callback for AppointmentSelection


  //! step 3 dummy data end


  //! step 4 appointment Data 
  const callbackAppointmentSelection = (selectedSlot, type) => {
    setShowAppointmentSelection(false);
    setCurrentStep(currentStep + 1 )
  };

  const handleBack = () => {
 
    setStep4next(false)
    setCurrentStep(2)
  };
  
  const handleContinueStep4 = () => {
  };


function getDurationIdFromText(durationText) {
  if (!durationText) return "1";

  // Extract numeric value from the text (e.g., "15 min" → 15)
  const match = durationText.match(/\d+/);
  if (!match) return "1";

  const durationValue = parseInt(match[0], 10);

  // Match duration in gpDuration
  if (gpDuration) {
    const durationEntry = Object.entries(gpDuration).find(
      ([, value]) => parseInt(value.duration) === durationValue
    );
    if (durationEntry) return durationEntry[0];
  }

  // Default fallback
  return durationValue <= 15 ? "1" : "2";
}

function getLanguageValue(languageName, languageData) {
  if (!languageName) return null;
  if (!languageData) return null;
  
  const lang = languageData.find(l => 
    l.label.toLowerCase() === languageName.toLowerCase()
  );
  return lang?.value ||  null;
}

const handleCancelAppointment = (data) => {
};

const handleRescheduleAppointment = (data) => {
  setHideDetails(true); // this triggers re-render
  setCurrentStep(2);
};
const onBookAgainPress = ()=>{
  navigate("/")
}



/// step 2 prefered time harcoded data 

 const  preferedProps  = 

 {
  "showAppoinmentData": {
    "oldDataExist":true,
      // "clinic": {
      //     "productCategory": {
      //         "title": encryptBookingDetails?.product_category_name || "",
      //         "product_category_id": productCategoryId
      //     }
      // },
      "clinic": {
        "productCategory": {
          "non_gp_product_id" : getProductNameOrIdByKeyword(ProductName)  , 
          "title": encryptBookingDetails?.product_category_name,
          "product_category_id": productCategoryId, // Assuming GP appointment
          "product_id" : getProductNameOrIdByKeyword(ProductName), 
          "prodcut_name" : ProductName  || null
        },
        "non_gp_product_id": getProductNameOrIdByKeyword(ProductName)
      },
      // "gender": encryptBookingDetails?.preferred_gender || encryptBookingDetails?.patient_gender || "male",
      // "language":  {
      //   "value": getLanguageValue(encryptBookingDetails?.language_name, gpLang),
      //   "label": encryptBookingDetails?.language_name || "English"
      // },  
      "language": getLanguageValue(encryptBookingDetails?.language_name, gpLang) || 1,
      "selectedLanguage" : { label : encryptBookingDetails?.language_name},
      "appointment_id" : encryptBookingDetails?.appointment_id, 
      "gender": encryptBookingDetails?.preferred_gender || encryptBookingDetails?.patient_gender || "no_preferance",

      "duration":  getDurationIdFromText(encryptBookingDetails?.duration_text),
      "type": "PreferredTime"
  },
  "data": {
      "clinic": {
          ...(originalBookingDetails.showAppoinmentData.clinicData),
      },
      "durationObjectById": gpDuration ,
      "allClinicData": allClinics , 
      "allClinicDataByID":combineAllClinicAndClinicById,
      "isProtected": false,
      "languageData": gpLang 
  },
  "getAllHealthScreenData": {
      "getAllHealthScreenData": {
          "data": [
              {
                  "id": 1,
                  "name": "Basic Health Check",
                  "product_category_id": 2
              }
          ]
      }
  }
}

const DateValidationProps={
  "date":encryptBookingDetails?.date_of_birth,
  onBack:()=>{ setCurrentStep(1)} }
// {...onBack=()=>(setCurrentStep(1)  )}


  /// hardcodded data end here 


  
  return (
    <>
    {/* {currentStep} */}
    {pageNotFound? 
    
    <NoPageFound data={"Sorry, the appointment does not exist."}/>
    
    :<div className="page-wrapper">
      {/* {currentStep} */}
      <div className="top-bar" style={{display:"none"}}>
        <div className="top-bar-inner">
          <div className="top-links">
            <span>For Patients</span>
            <span>For Business Customers</span>
            <span>Become a Member</span>
          </div>
        </div>
      </div>
      <header className="header">
        <div className="logo">
          <img src={"https://pbldcbe.webdezign.uk/static/media/ldc_logo_new.1f2a7d791d5f16307994.png"} alt="Logo" className="logo-img" />
        </div>
        <div className=" desktop-only">
          <div className="header-link">
            <ChevronRight size={12} />
            <span>Book online</span>
          </div>
          <div className="contact-call">
            <ChevronRight size={12} />
            <span>Or call 020 3993 0813</span>
          </div>
        </div>
        <div className="mobile-only">
          <span className="phone-number">
            <Phone size={20} />
          </span>
          <button className="hamburger">☰</button>
        </div>
      </header>
      

      <main className="main">
        {/* <h1>{currentStep}</h1> */}
      {currentStep==0 && <DateValidation{...DateValidationProps}  />}
      {(currentStep === 1 ) && (
          <div
            style={{
              backgroundColor: "rgba(0, 131, 133, 0.25)",
              color: "#008385",
              padding: "16px 24px",
              marginBottom: "20px",
              fontWeight: "400",
              fontSize: "18px"
            }}
          >
            {currentStep === 1 ? "My booking" : "Original booking"}
          </div>
        )}

        {currentStep === 1 && gpLang?.length > 0 &&  (
          // <BookingJourney onNext={()=>(  setCurrentStep(2))}/>
          <>
            <BookingDetailsNext 
            {...originalBookingDetails}
            handleCancelAppointment={handleCancelAppointment}
            handleRescheduleAppointment={handleRescheduleAppointment}
            onBookAgain={onBookAgainPress}
            />
          </>
        )}
        {/* RESCHEDULE FLOW  */}
        {currentStep === 2 && (
        <>
          <BookingDetailsNext 
            {...originalBookingDetails}
            hide={hideDetails} // override hide here
            handleCancelAppointment={handleCancelAppointment}
            handleRescheduleAppointment={handleRescheduleAppointment}
          />        
          <PreferredTime
          check={dataExists}
            // showAppoinmentData={originalBookingDetails.showAppoinmentData}
            // data={originalBookingDetails.data}
            metaData={getAppointmentDownPart.showAppoinmentData}
            callback={callbackClinicBooking}
             goback={()=>setCurrentStep(currentStep-1)}
            // callBackForbackpage={callBackForbackpagePreferredTime}
            // getAllHealthScreenData={
            //   universalDummyData.getAllHealthScreenData
            // }
            {...preferedProps}
          />

          {showAppointmentSelection && (
                <AppointmentSelection  
                  showAppoinmentData={getAppointmentDownPart.showAppoinmentData}
                  data={getAppointmentDownPart.data}
                  callback={callbackAppointment} 
                  callBackForbackpage={() => {setShowAppointmentSelection(false);setDataExists(true)} }
                />
              )}

              {step4next&&( <Step4
                onBack={handleBack}
                // onBack={ok}
                onContinue={handleContinueStep4}
                bookingDetails={bookingDetails}
              />)}
             
        
        
        </>



        )}

        {currentStep === 4 && (
                <Step4
                onBack={handleBack}
                // onBack={ok}
                onContinue={handleContinueStep4}
                bookingDetails={bookingDetails}
              />
                  ) }
      </main>

      <footer className="footer">
        <div className="logo" style={{display:"flex",justifyContent:"center"}}>
          <img src={"https://pbldcbe.webdezign.uk/static/media/ldc_logo_new.1f2a7d791d5f16307994.png"} alt="Logo" style={{ height: "40px" }} />
        </div>
      </footer>


    </div>}
    </>
    
  );
};

export default ReschedulePage;

